<template>
  <div class="l-edit-dialog-box">
    <div class="l-edit-dialog-p-box">
      <div class="l-edit-dialog-width-limit">

        <el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left">
          <div class="ivu-mb">
            <l-auth-button type="info" auth="place_download_template_btn" @click="downloadTemplate" :loading="import_loading"> 下载导入模板 </l-auth-button>
          </div>
          <el-form-item :label="EXCEL" prop="excel">

            <l-upload class="upload-demo" drag method="account_importExcel" accept=".xls,.xlsx" name="excel" :on-success="handleUploadSuccess" :limit="1">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text"> 将文件拖到此处，或<em>点击上传</em></div>
              <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件</div>
            </l-upload>
            <!-- <span>只能上传xls/xlsx文件</span> -->
          </el-form-item>

        </el-form>
      </div>
    </div>

    <div class="l-dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </div>

</template>

<script>
import Vue from "vue";
export default {
  name: "l-place-import_s",
  props: {
    visible: {
      type: Boolean,
    },
  },
  data() {
    return {
      //上传地址
      upload_url: Vue.$_config.upload_url,
      import_loading: false,
      //表单数据
      form_data: {
        excel: "",
      },
      export_loading: false,
      //表单验证规则
      rules: {
        excel: [
          {
            required: true,
            message: "请上传文件",
            trigger: "change",
          },
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },

  mounted() {
    //  console.log('进来');
    //  console.log(this.upload_url);
  },

  watch: {},

  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    //上传成功回掉  
    handleUploadSuccess(response) {
       console.log('进来');
      console.log(response);
      this.form_data.excel = response.data.url_path;
    },

    //提交数据
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          this.$_invoke("account_accountImport", this.form_data)
            .then((ret) => {
              if (ret.length == 0) {
                this.$_msg.success("导入成功");
              } else {
                this.$_msg.error(ret);
              }
              this.$emit("on-success");
            })
            .finally(() => {
              this.submitting = false;
            });
        }
      });
    },
    downloadTemplate() {
      this.export_loading = true;

      this.$_invoke("account_exportTemplate")
        .then((ret) => {
          window.open(ret);
        })
        .finally(() => {
          this.export_loading = false;
        });
    }
  },
};
</script>